import { Injectable } from '@angular/core';
import { UserDataService } from '../userData/user-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { CommonService } from '../common/common.service';
import { map, catchError } from 'rxjs/operators';
import axios from 'axios';
import { handleGenericTechnicalError, handleUnauthorizedResponse } from 'src/app/util/servicesUtil';

@Injectable({
	providedIn: 'root'
})
export class UserProfileService {
	constructor(public http: HttpClient, public userService: UserDataService) { }

	private extractData(res: Response) {
		let body = res;
		return body || {};
	}

	getUserProfileAxios = async (token: any, emailId: any) => {
		let url = CommonService.BASE_URL + '/api/v1/secure/profile/fetch/' + emailId;
		const result = await axios.get(url, {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${token}`
			}
		});
		if (result.status === 200) {
			if (result && result.data.college && result.data.college.id) {
				sessionStorage.setItem('collegeId', result.data.college.id);
				sessionStorage.setItem('userId', result.data.id);

				// Save college logo to sessionStorage
				const logoUrl = result.data.college.logoUrl ||
					(result.data.college.logo ? `data:image/jpeg;base64,${result.data.college.logo}` : null);

				if (logoUrl) {
					this.userService.saveCollegeLogo(logoUrl);
				}
			}
			return result.data;
		} else if (result.status === 403) {
			handleUnauthorizedResponse();
		} else {
			handleGenericTechnicalError();
		}
	};

	getUserProfile(token: any, emailId: any): Observable<any> {
		let url = CommonService.BASE_URL + '/api/v1/secure/profile/fetch/' + emailId;
		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};

		return this.http.get(url, httpOptions).pipe(
			map((res: any) => {
				// store collegeId in sessionStorage if present
				if (res && res.college && res.college.id) {
					sessionStorage.setItem('collegeId', res.college.id);

					// Save college logo to sessionStorage
					const logoUrl = res.college.logoUrl ||
						(res.college.logo ? `data:image/jpeg;base64,${res.college.logo}` : null);

					if (logoUrl) {
						this.userService.saveCollegeLogo(logoUrl);
					}
				}
				return this.extractData(res);
			}),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					console.error('An error occurred:', error.error.message);
				} else {
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				return throwError('Something bad happened; please try again later.');
			})
		);
	}

	getallUserProfileForCollege(token: any, collegeId: any): Observable<any> {
		let url = CommonService.BASE_URL + '/api/v1/secure/profile/get/all-by-college-lite/' + collegeId;
		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};
		return this.http.get(url, httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					console.error('An error occurred:', error.error.message);
				} else {
					// The backend returned an unsuccessful response code.
					// The response body may contain clues as to what went wrong,
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				// return an observable with a user-facing error message
				return throwError('Something bad happened; please try again later.');
			})
		);
	}

	getallUserProfileForCollegeActiveInactive(token: any, collegeId: any): Observable<any> {
		let url = CommonService.BASE_URL + '/api/v1/secure/profile/get/all-by-college-lite/all/' + collegeId;
		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};
		return this.http.get(url, httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					console.error('An error occurred:', error.error.message);
				} else {
					// The backend returned an unsuccessful response code.
					// The response body may contain clues as to what went wrong,
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				// return an observable with a user-facing error message
				return throwError('Something bad happened; please try again later.');
			})
		);
	}

	getallUserProfileForCollegeSharable(token: any, collegeId: any): Observable<any> {
		let url = CommonService.BASE_URL + '/api/v1/secure/profile/get/all-sharable-staff/' + collegeId;
		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};
		return this.http.get(url, httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					console.error('An error occurred:', error.error.message);
				} else {
					// The backend returned an unsuccessful response code.
					// The response body may contain clues as to what went wrong,
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				// return an observable with a user-facing error message
				return throwError('Something bad happened; please try again later.');
			})
		);
	}

	getAllMetricNumbers(token: any, payload: any) {
		let url = CommonService.BASE_URL + '/api/v1/public/metadata/metric/byCriteriaAndMetricType';
		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};
		return this.http.put(url, payload, httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					console.error('An error occurred:', error.error.message);
				} else {
					// The backend returned an unsuccessful response code.
					// The response body may contain clues as to what went wrong,
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				// return an observable with a user-facing error message
				return throwError('Something bad happened; please try again later.');
			})
		);
	}

	updateUserProfile(token: any, payload): Observable<any> {
		let url = CommonService.BASE_URL + '/api/v1/secure/profile/update/';
		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};
		return this.http.put(url, payload, httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					console.error('An error occurred:', error.error.message);
				} else {
					// The backend returned an unsuccessful response code.
					// The response body may contain clues as to what went wrong,
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				// return an observable with a user-facing error message
				return throwError('Something bad happened; please try again later.');
			})
		);
	}

	getPushToken(token, payload): Observable<any> {
		let url = CommonService.BASE_URL + '/api/v1/secure/profile/pushToken/';
		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};
		return this.http.put(url, payload, httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					console.error('An error occurred:', error.error.message);
				} else {
					// The backend returned an unsuccessful response code.
					// The response body may contain clues as to what went wrong,
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				// return an observable with a user-facing error message
				return throwError('Something bad happened; please try again later.');
			})
		);
	}

	getallIQACUserProfileForCollege(token: any, collegeId: any): Observable<any> {
		let url = CommonService.BASE_URL + '/api/v1/secure/profile/get/all-iqac-for-college/' + collegeId;
		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};
		return this.http.get(url, httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					console.error('An error occurred:', error.error.message);
				} else {
					// The backend returned an unsuccessful response code.
					// The response body may contain clues as to what went wrong,
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				// return an observable with a user-facing error message
				return throwError('Something bad happened; please try again later.');
			})
		);
	}
	uploadPhoto(token: any, payload: any, userId: any): Observable<any> {
		let url = CommonService.BASE_URL + '/api/v1/secure/profile/uploadphoto/' + userId;
		let httpOptions = {
			headers: new HttpHeaders({
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};
		return this.http.put(url, payload, httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					console.error('An error occurred:', error.error.message);
				} else {
					// The backend returned an unsuccessful response code.
					// The response body may contain clues as to what went wrong,
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				// return an observable with a user-facing error message
				return throwError('Something bad happened; please try again later.');
			})
		);
	}
	deactivateProfile(token: any, userId): Observable<any> {
		let url = CommonService.BASE_URL + '/api/v1/secure/profile/deactivate/' + userId;
		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};
		return this.http.post(url, [], httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					console.error('An error occurred:', error.error.message);
				} else {
					// The backend returned an unsuccessful response code.
					// The response body may contain clues as to what went wrong,
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				// return an observable with a user-facing error message
				return throwError('Something bad happened; please try again later.');
			})
		);
	}

	activateProfile(token: any, userId): Observable<any> {
		let url = CommonService.BASE_URL + '/api/v1/secure/profile/activate/' + userId;
		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};
		return this.http.post(url, [], httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					console.error('An error occurred:', error.error.message);
				} else {
					// The backend returned an unsuccessful response code.
					// The response body may contain clues as to what went wrong,
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				// return an observable with a user-facing error message
				return throwError('Something bad happened; please try again later.');
			})
		);
	}

	deleteProfile(token: any, userId): Observable<any> {
		let url = CommonService.BASE_URL + '/api/v1/secure/profile/delete/' + userId;
		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};
		return this.http.post(url, [], httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					console.error('An error occurred:', error.error.message);
				} else {
					// The backend returned an unsuccessful response code.
					// The response body may contain clues as to what went wrong,
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				// return an observable with a user-facing error message
				return throwError('Something bad happened; please try again later.');
			})
		);
	}

	// --------TEMPRORY-BYPASS-FOR-DEPARTMENT-AND-COMMITTEE-LIST------------------//
	getAllCommitteeForCollage(token: any, collageId: any): Observable<any> {
		let url = CommonService.BASE_URL + '/api/v1/secure/committee/fetch/' + collageId;

		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};
		return this.http.get(url, httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					console.error('An error occurred:', error.error.message);
				} else {
					// The backend returned an unsuccessful response code.
					// The response body may contain clues as to what went wrong,
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				// return an observable with a user-facing error message
				return throwError('Something bad happened; please try again later.');
			})
		);
	}
	getAllDepartmentForCollage(token: any, collageId: any): Observable<any> {
		let url = CommonService.BASE_URL + '/api/v1/secure/departmet/fetch/' + collageId;

		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};
		return this.http.get(url, httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					console.error('An error occurred:', error.error.message);
				} else {
					// The backend returned an unsuccessful response code.
					// The response body may contain clues as to what went wrong,
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				// return an observable with a user-facing error message
				return throwError('Something bad happened; please try again later.');
			})
		);
	}

	fetchTokenDtoObjectAxios = async (token: any, user: any) => {
		let url = CommonService.BASE_URL + '/api/v1/secure/profile/tokenObject';
		const result = await axios.post(url, user, {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${token}`
			}
		});
		if (result.status === 200) {
			return result.data;
		} else if (result.status === 403) {
			handleUnauthorizedResponse();
		} else {
			handleGenericTechnicalError();
		}
	};

	fetchTokenDtoObject(token: any, user: any) {
		let url = CommonService.BASE_URL + '/api/v1/secure/profile/tokenObject';
		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};
		return this.http.post(url, user, httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					console.error('An error occurred:', error.error.message);
				} else {
					// The backend returned an unsuccessful response code.
					// The response body may contain clues as to what went wrong,
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				// return an observable with a user-facing error message
				return throwError('Something bad happened; please try again later.');
			})
		);
	}

	getAppVersionStatusList(os: any, version: any): Observable<any> {
		let url = CommonService.BASE_URL + '/api/v1/public/app-version-check/' + os + '/' + version;
		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json'
			})
		};
		return this.http.get(url, httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					console.error('An error occurred:', error.error.message);
				} else {
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
				}
				return throwError('Something bad happened; please try again later.');
			})
		);
	}

	getProfileCompletionDetails(token: any) {
		let url = CommonService.BASE_URL + '/api/v1/secure/profileCompletion';
		let httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			})
		};
		return this.http.get(url, httpOptions).pipe(
			map(this.extractData),
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					console.error('An error occurred:', error.error.message);
				} else {
					// The backend returned an unsuccessful response code.
					// The response body may contain clues as to what went wrong,
					console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				// return an observable with a user-facing error message
				return throwError('Something bad happened; please try again later.');
			})
		);
	}

	uploadCollegeLogo(token: any, collegeId: any, payload: any) {
		const url = CommonService.BASE_URL + '/api/v1/secure/collage/upload-college-logo/' + collegeId;

		const httpOptions = {
			headers: new HttpHeaders({
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			}),
			observe: 'response' as const
		};

		return this.http.put(url, payload, httpOptions).pipe(
			catchError((error) => {
				if (error.error instanceof ErrorEvent) {
					console.error('An error occurred:', error.error.message);
				} else {
					console.error(`Backend returned code ${error.status}, body was: ${error.error}`);
					if (error.status === 403) {
						window.dispatchEvent(new CustomEvent('user:force-logout'));
					}
				}
				return throwError(() => error);
			})
		);
	}
}
